import { stat } from 'fs';
import { PERMISSIONS_SET, PERMISSIONS_ADDED, PERMISSIONS_EDITED } from 'src/app/redux/redux-types';
import { reduxPermissionsTypes } from 'src/types';

export const permissionDefaultState: reduxPermissionsTypes.StateType = {
  permissions: [],
};

export const permissionReducer = (
  state = permissionDefaultState,
  action: reduxPermissionsTypes.ActionType,
): reduxPermissionsTypes.StateType => {
  switch (action.type) {
    case PERMISSIONS_SET:
      return {
        ...state,
        permissions: action.payload,
      };
    case PERMISSIONS_ADDED:
      return {
        ...state,
        permissions: [...state.permissions, action.payload],
      };
    case PERMISSIONS_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.permissions.findIndex((obj) => obj.staticId === action.payload.staticId);
      return {
        ...state,
        permissions: [
          ...state.permissions.slice(0, updateIndex),
          action.payload,
          ...state.permissions.slice(updateIndex + 1),
        ],
      };
    default:
      return state;
  }
};
